var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6654 35.6418H3.33203C2.6487 35.6418 2.08203 36.1807 2.08203 36.8304C2.08203 37.4802 2.6487 38.0191 3.33203 38.0191H36.6654C37.3487 38.0191 37.9154 37.4802 37.9154 36.8304C37.9154 36.1807 37.3487 35.6418 36.6654 35.6418Z",
    fill: "#25BBBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28.3333 5.13428H11.6667C6.66667 5.13428 5 7.97108 5 11.4735V36.8304H35V11.4735C35 7.97108 33.3333 5.13428 28.3333 5.13428Z",
    fill: "#25BBBB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.668 29.3027H11.668C10.9846 29.3027 10.418 28.7639 10.418 28.1141C10.418 27.4644 10.9846 26.9255 11.668 26.9255H16.668C17.3513 26.9255 17.918 27.4644 17.918 28.1141C17.918 28.7639 17.3513 29.3027 16.668 29.3027Z",
    fill: "#25BBBB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.332 29.3027H23.332C22.6487 29.3027 22.082 28.7639 22.082 28.1141C22.082 27.4644 22.6487 26.9255 23.332 26.9255H28.332C29.0154 26.9255 29.582 27.4644 29.582 28.1141C29.582 28.7639 29.0154 29.3027 28.332 29.3027Z",
    fill: "#25BBBB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.668 22.1712H11.668C10.9846 22.1712 10.418 21.6323 10.418 20.9826C10.418 20.3328 10.9846 19.7939 11.668 19.7939H16.668C17.3513 19.7939 17.918 20.3328 17.918 20.9826C17.918 21.6323 17.3513 22.1712 16.668 22.1712Z",
    fill: "#25BBBB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.332 22.1712H23.332C22.6487 22.1712 22.082 21.6323 22.082 20.9826C22.082 20.3328 22.6487 19.7939 23.332 19.7939H28.332C29.0154 19.7939 29.582 20.3328 29.582 20.9826C29.582 21.6323 29.0154 22.1712 28.332 22.1712Z",
    fill: "#25BBBB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.668 15.0393H11.668C10.9846 15.0393 10.418 14.5005 10.418 13.8507C10.418 13.2009 10.9846 12.6621 11.668 12.6621H16.668C17.3513 12.6621 17.918 13.2009 17.918 13.8507C17.918 14.5005 17.3513 15.0393 16.668 15.0393Z",
    fill: "#25BBBB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.332 15.0393H23.332C22.6487 15.0393 22.082 14.5005 22.082 13.8507C22.082 13.2009 22.6487 12.6621 23.332 12.6621H28.332C29.0154 12.6621 29.582 13.2009 29.582 13.8507C29.582 14.5005 29.0154 15.0393 28.332 15.0393Z",
    fill: "#25BBBB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.0391,
    y: 1.67627,
    width: 8.81352,
    height: 7.82192,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.3441 11.407H35.3825C37.559 11.407 38.8614 10.1685 38.8614 8.09895V3.30802C38.8614 1.23847 37.559 0 35.3825 0H30.3441C28.1677 0 26.8652 1.23847 26.8652 3.30802V8.09895C26.8652 10.1685 28.1677 11.407 30.3441 11.407ZM31.3873 2.30403C30.8084 1.75356 29.8929 1.77661 29.3424 2.35551C28.792 2.93441 28.815 3.84995 29.3939 4.40042L30.6418 5.58706L29.3939 6.7737C28.815 7.32417 28.792 8.2397 29.3424 8.81861C29.8929 9.39751 30.8084 9.42056 31.3873 8.87009L32.7409 7.58302L34.0945 8.87009C34.6734 9.42056 35.5889 9.39751 36.1394 8.81861C36.6898 8.23971 36.6668 7.32417 36.0879 6.7737L34.84 5.58706L36.0879 4.40042C36.6668 3.84995 36.6898 2.93441 36.1394 2.35551C35.5889 1.77661 34.6734 1.75356 34.0945 2.30403L32.7409 3.5911L31.3873 2.30403Z",
    fill: "#454F5D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.935301d7ba7a51565779085b8eceb8fb.svg";
export { ForwardRef as ReactComponent };